import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import {
    Form,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Input
} from 'reactstrap';

interface DataTypes {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    displayName: string;
}
interface CreateContactModalProps {
    isOpen: boolean;
    onClose: () => void;
    onCreate: (data: any) => void;
}
const CreateContactModal = ({
    isOpen,
    onClose,
    onCreate
}: CreateContactModalProps) => {
    /* data input handeling */
    const [data, setData] = useState<DataTypes>({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        displayName: ''
    });

    useEffect(() => {
        setData({
            firstName: '',
            lastName: '',
            phoneNumber: '',
            displayName: ''
        });
    }, []);

    const onChangeData = (
        field: 'firstName' | 'lastName' | 'phoneNumber' | 'displayName',
        value: string
    ) => {
        let modifiedData: DataTypes = { ...data };
        if (value === '') {
            modifiedData[field] = '';
        } else if (field === 'phoneNumber') {
            modifiedData[field] = `+${value.replace(/\D/g, '')}`;
        } else {
            modifiedData[field] = value;
        }
        setData(modifiedData);
    };

    /* validation */
    const [valid, setValid] = useState<boolean>(false);
    useEffect(() => {
        if (
            data.firstName !== '' &&
            data.lastName !== '' &&
            data.phoneNumber !== '' &&
            data.displayName !== ''
        ) {
            setValid(true);
        } else {
            setValid(false);
        }
    }, [data]);
    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            tabIndex={-1}
            centered
            scrollable
        >
            <ModalHeader toggle={onClose} className="bg-primary">
                <div className="modal-title-custom text-white font-size-16 ">
                    Create Contact
                </div>
            </ModalHeader>
            <ModalBody className="p-4">
                <Form>
                    <div className="mb-3">
                        <Label
                            htmlFor="CreateContactModalfirstName-input"
                            className="form-label"
                        >
                            First Name
                        </Label>
                        <Input
                            type="text"
                            className="form-control"
                            id="CreateContactModalfirstName-input"
                            placeholder="Enter First Name"
                            value={data['firstName'] || ''}
                            onChange={(e: any) => {
                                onChangeData('firstName', e.target.value);
                            }}
                        />
                    </div>
                    <div className="mb-3">
                        <Label
                            htmlFor="CreateContactModallastName-input"
                            className="form-label"
                        >
                            Last Name
                        </Label>
                        <Input
                            type="text"
                            className="form-control"
                            id="CreateContactModallastName-input"
                            placeholder="Enter Last Name"
                            value={data['lastName'] || ''}
                            onChange={(e: any) => {
                                onChangeData('lastName', e.target.value);
                            }}
                        />
                    </div>
                    <div className="mb-3">
                        <Label
                            htmlFor="CreateContactModalphoneNumber-input"
                            className="form-label"
                        >
                            Phone Number
                        </Label>
                        <InputMask
                            className="form-control"
                            mask="+1 (999) 999-9999"
                            maskChar={''}
                            placeholder="Enter phone number"
                            value={data['phoneNumber'] || ''}
                            onChange={(e: any) => {
                                onChangeData('phoneNumber', e.target.value);
                            }}
                            alwaysShowMask={false}
                        />
                    </div>
                    <div className="mb-3">
                        <Label
                            htmlFor="CreateContactModaldisplayName-input"
                            className="form-label"
                        >
                            Display Name
                        </Label>
                        <Input
                            type="text"
                            className="form-control"
                            id="CreateContactModaldisplayName-input"
                            placeholder="Enter Alias"
                            value={data['displayName'] || ''}
                            onChange={(e: any) => {
                                onChangeData('displayName', e.target.value);
                            }}
                            onFocus={() => {
                                onChangeData(
                                    'displayName',
                                    `${data['firstName']} ${data['lastName']}`
                                );
                            }}
                        />
                    </div>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    color="link"
                    className="btn"
                    onClick={onClose}
                >
                    Close
                </Button>
                <Button
                    type="button"
                    color="primary"
                    disabled={!valid}
                    onClick={() => onCreate(data)}
                >
                    Create
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default CreateContactModal;
